import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import { TOLL_PATH } from '../../../../config/paths';
import { getToll, clearToll } from '../../../../actions';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import AddressResource from '../../../common/resource/AddressResource';
import InternalResource from '../../../common/resource/InternalResource';

import TollBasicInformationResource from './resources/TollBasicInformationResource';
import TollToolBar from './TollToolBar';

export const Toll = ({
  breadcrumbs,
  dispatchGetToll,
  dispatchClearToll,
  match: {
    params: { id: tollId },
  },
  loading,
  toll,
}) => {
  useLayoutEffect(() => {
    dispatchGetToll({ tollId });

    return () => dispatchClearToll();
  }, []);

  let content;
  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (toll.isEmpty()) {
    content = <NoDataResource returnPage={TOLL_PATH} />;
  } else {
    const tollJson = toll.toJS();

    content = (
      <Row>
        <Col md={6}>
          <h3>Información Básica</h3>
          <TollBasicInformationResource {...tollJson} />

          <div className="mb-3">
            <h3>Dirección</h3>
            <AddressResource address={tollJson.location.address} />
          </div>

          <InternalResource {...tollJson} />
        </Col>
      </Row>
    );

    toolbar = <TollToolBar tollId={tollJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Peaje"
      content={content}
    />
  );
};

Toll.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetToll: PropTypes.func.isRequired,
  dispatchClearToll: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  toll: PropTypes.instanceOf(Immutable.Map).isRequired,
};

Toll.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetToll: getToll,
  dispatchClearToll: clearToll,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes',
      href: TOLL_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],

  toll: RouteUnit.Toll.getIn(['current', 'content']),

  loading: !RouteUnit.Toll.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toll);
